import { render, staticRenderFns } from "./RelatorSubTab.vue?vue&type=template&id=0f17d14e&"
import script from "./RelatorSubTab.vue?vue&type=script&lang=js&"
export * from "./RelatorSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports